import { STATUS_TYPE } from '../../../enum';

export interface GetCakeBox {
  id: string;
}

export interface FindCakeBox {
  search?: string;
  limit?: number;
  skip?: number;
  activeOnly?: boolean;
}

export interface CreatePatchCakeBox {
  id?: string;
  labelEn: string;
  labelAr: string;
  imgUrl?: string | null;
  price: number | string;
  position: string | number;
  activeState: boolean;
}

export interface CakeBox {
  id: string;
  labelEn: string;
  labelAr: string;
  imgUrl?: string | null;
  price: number;
  position: number | string;
  activeState: boolean;
  createdBy?: string;
  updatedBy?: string;
  updatedAt?: string;
  createdAt?: string;
}

interface InitialState {
  data: CakeBox[];
  skip: number;
  limit: number;
  totalRecords: number;
  currentPage: number;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: [],
  skip: 0,
  limit: 25,
  totalRecords: 0,
  currentPage: 0,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};
